import type React from 'react'

import { RouterProvider } from 'react-router-dom'
import 'fonts.css'
import 'toast.css'

import { AppProvider } from 'providers/AppProvider'
import { ToastContainer } from 'react-toastify'

import router from './routes'

const App: React.FC = () => {
  return (
    <AppProvider>
      <ToastContainer
        autoClose={5000}
        closeOnClick
        draggable
        hideProgressBar={false}
        newestOnTop={false}
        pauseOnFocusLoss
        pauseOnHover
        position="top-right"
        rtl={false}
      />
      <RouterProvider router={router} />
    </AppProvider>
  )
}

export default App
